import styled from 'styled-components';

export const FilterShell = styled.div`
    display: inline-flex;
    align-items: center;
    height: 32px;
    padding: 0 4px;
    gap: 2px;
    border: 1.5px dashed var(--color-border, #d1d5db);
    border-radius: 9999px;
    background: transparent;
    color: var(--color-foreground, #111827);

    &:hover {
        border-color: var(--color-border-hover, #9ca3af);
    }
`;

export const PeriodStepButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 9999px;
    background: transparent;
    color: inherit;
    cursor: pointer;
    flex-shrink: 0;

    &:disabled {
        opacity: 0.35;
        cursor: not-allowed;
    }

    &:hover:not(:disabled) {
        background: var(--color-muted, #f3f4f6);
    }
`;

export const PeriodLabelButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 24px;
    padding: 0 8px;
    border: none;
    border-radius: 9999px;
    background: transparent;
    font-size: 14px;
    font-weight: 500;
    line-height: 1;
    color: inherit;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
        background: var(--color-muted, #f3f4f6);
    }

    &[data-state='open'] {
        background: var(--color-muted, #f3f4f6);
    }
`;

export const PopoverPanel = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 10px;
`;

export const YearHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
`;

export const YearLabel = styled.p`
    margin: 0;
    font-size: 13px;
    font-weight: 600;
    color: var(--color-foreground, #111827);
`;

export const YearStepButton = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 6px;
    background: transparent;
    color: var(--color-foreground, #111827);
    cursor: pointer;

    &:disabled {
        opacity: 0.35;
        cursor: not-allowed;
    }

    &:hover:not(:disabled) {
        background: var(--color-muted, #f3f4f6);
    }
`;

export const MonthGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 4px;
`;

export const MonthCellButton = styled.button<{ $isSelected: boolean }>`
    height: 30px;
    border: none;
    border-radius: 6px;
    background: ${({ $isSelected }) =>
        $isSelected ? 'var(--color-primary, #2563eb)' : 'transparent'};
    color: ${({ $isSelected }) => ($isSelected ? '#fff' : 'var(--color-foreground, #111827)')};
    font-size: 12px;
    font-weight: ${({ $isSelected }) => ($isSelected ? 600 : 500)};
    cursor: pointer;

    &:disabled {
        opacity: 0.35;
        cursor: not-allowed;
    }

    &:hover:not(:disabled):not([data-selected='true']) {
        background: var(--color-muted, #f3f4f6);
    }
`;
